function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx } from "react/jsx-runtime";
import { isEmpty } from "lodash";
import React from "react";
function mergeSpans(_spans) {
    if (!_spans || !_spans.length) {
        return [];
    }
    var spans = _spans.map(function(span) {
        return _object_spread({}, span);
    });
    spans.sort(function(a, b) {
        if (a.start === b.start) {
            return a.end - b.end;
        }
        return a.start - b.start;
    });
    var first = _object_spread_props(_object_spread({}, spans[0]), {
        types: [
            spans[0].type
        ]
    });
    delete first.type;
    var mergedSpans = [
        first
    ];
    for(var i = 1; i < spans.length; i++){
        var toBeMerged = spans[i];
        var lastSpan = mergedSpans[mergedSpans.length - 1];
        if (lastSpan.end < toBeMerged.start) {
            mergedSpans.push(_object_spread_props(_object_spread({}, toBeMerged), {
                types: [
                    toBeMerged.type
                ]
            }));
            delete mergedSpans[mergedSpans.length - 1].type;
        } else if (lastSpan.start === toBeMerged.start) {
            lastSpan.types.push(toBeMerged.type);
            toBeMerged.start = lastSpan.end + 1;
            mergedSpans.push(_object_spread_props(_object_spread({}, toBeMerged), {
                types: [
                    toBeMerged.type
                ]
            }));
            delete mergedSpans[mergedSpans.length - 1].type;
        } else {
            var lastSpanEnd = lastSpan.end;
            lastSpan.end = toBeMerged.start - 1;
            lastSpan.types.push(toBeMerged.type);
            mergedSpans.push(_object_spread_props(_object_spread({}, toBeMerged), {
                types: [
                    toBeMerged.type
                ]
            }));
            delete mergedSpans[mergedSpans.length - 1].type;
            if (toBeMerged.end < lastSpanEnd) {
                mergedSpans.push({
                    start: toBeMerged.end + 1,
                    end: lastSpanEnd,
                    types: lastSpan.types
                });
            }
        }
    }
    return mergedSpans;
}
/**
 * RichText component
 * @param {{
 *  text: string,
 *  spans: Array<{ start: number, end: number, type: "em" | "strong" }>,
 * }} props
 */ function RichText(props) {
    var text = props.text, spans = props.spans, type = props.type, url = props.url, id = props.id;
    if ((!text || isEmpty(text)) && type !== "image") {
        return /*#__PURE__*/ _jsx("br", {});
    }
    var parts = [];
    var lastIndex = 0;
    var mergedSpans = mergeSpans(spans);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = mergedSpans[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, start = _step_value.start, end = _step_value.end, types = _step_value.types, data = _step_value.data;
            var lastPart = text.slice(lastIndex, start);
            !isEmpty(lastPart) && parts.push(/*#__PURE__*/ _jsx("span", {
                children: lastPart
            }, lastPart));
            var currentPart = text.slice(start, end);
            !isEmpty(currentPart) && parts.push(/*#__PURE__*/ _jsx("span", {
                className: types.join(" "),
                children: !isEmpty(data) ? /*#__PURE__*/ _jsx("a", {
                    href: data.url,
                    children: currentPart
                }) : currentPart
            }, currentPart));
            lastIndex = end;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var finalPart = text === null || text === void 0 ? void 0 : text.slice(lastIndex);
    !isEmpty(finalPart) && parts.push(/*#__PURE__*/ _jsx("span", {
        children: finalPart
    }, finalPart));
    if (type.includes("heading")) {
        var /*#__PURE__*/ _React;
        return (_React = React).createElement.apply(_React, [
            "h".concat(type.split("heading")[1]),
            {
                className: "rich-text-heading",
                id: id !== null && id !== void 0 ? id : ""
            }
        ].concat(_to_consumable_array(parts)));
    }
    if (type === "image") {
        return /*#__PURE__*/ _jsx("img", {
            className: "rich-text-image ",
            src: url,
            alt: ""
        });
    }
    return /*#__PURE__*/ _jsx("p", {
        className: "rich-text-paragraph",
        children: parts
    });
}
export default RichText;
